import { useFormState } from 'react-final-form'

import Button from 'common/components/button'
import DynamicFields from 'common/components/dynamicFields'
import { FieldsConfiguration } from 'common/components/dynamicFields/interfaces'
import { ArrowRight as ArrowRightIcon } from 'common/icons'

import { PageState } from './BriefPage'

type Props = {
  isDisabled: boolean
  isGeneratingVariants: boolean
  fieldsConfiguration: FieldsConfiguration
  pageState: PageState
}

const DynamicForm = ({
  isDisabled,
  fieldsConfiguration,
  isGeneratingVariants,
  pageState,
}: Props) => {
  const formState = useFormState()

  return (
    <>
      <div className="w-150">
        <DynamicFields
          fieldsConfiguration={fieldsConfiguration}
          isDisabled={isDisabled}
        />
      </div>
      {pageState === 'generateBrief' && (
        <div className="flex pt-6 justify-end items-center">
          <Button
            type="submit"
            data-cy="content-generate-brief-button"
            variant="primary"
            disabled={formState.invalid}
            suffixIcon={<ArrowRightIcon isDefaultColor={false} size={4} />}
            loading={isGeneratingVariants}
          >
            Generate brief
          </Button>
        </div>
      )}
    </>
  )
}

export default DynamicForm
